import { OPERATION_METHOD, OPERATION_METHOD_COLORS, OPERATION_METHOD_COLORS_DARK } from '~/types/content'

export const getOperationColor = (method: OPERATION_METHOD, isDark: boolean) => isDark ? OPERATION_METHOD_COLORS_DARK[method.toLowerCase()] : OPERATION_METHOD_COLORS[method.toLowerCase()]